import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-member-chase-dw",
  templateUrl: "./member-chase-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberChaseDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.MEMBER_STATUS_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID];
}
